import { create } from "../../../common/utils/zustand_state_manager";
import { IAdministracaoRepository } from "../../../features/administracao/domain/repositories/administracao_repository";
import { useAdministracaoServices } from "./use_services";
import { AdministracaoRepository } from "../../../features/administracao/data/repositories/administracao_repository";


/**
 * useAdministracaoRepositories
 */

type State = {
  administracaoRepository: IAdministracaoRepository,
};

export const useAdministracaoRepositories = create<State>((set, get) => {
  const { administracaoService } = useAdministracaoServices.getState();
  return ({
    administracaoRepository: new AdministracaoRepository(administracaoService),
  });
});